import React from 'react'
import Footer from './Footer'

const Foot = () => {
  return (
    <div >
      <Footer/>
    </div>
  )
}

export default Foot
